<template>
  <div id="app">
    <NavigationBar></NavigationBar>

    <div class="main-container">
      <router-view></router-view>
    </div>

    <div class="wrapper">
      <footer>
        <p>Powered by <a href="https://airgateway.net">AirGateway</a> - The NDC Gateway Company - <a
            href="/privacy-policy">Privacy Policy</a></p>
      </footer>
    </div>

    <notifications group="foo" position="bottom center"/>
  </div>
</template>

<script>
import Vue from 'vue';
import VueRouter from 'vue-router';
import NavigationBar from './components/shared/+navigation-bar'
import index from './components/index';
import signup from "./components/auth/signup";
import analytics from "./components/analytics";
import dashboard from "./components/dashboard";
import profile from "./components/profile";
import airlines from "./components/airlines";
import applications from "./components/applications";
import privacy_policy from "./components/privacy_policy";
import helpers from "@/mixins/helpers";
import axios from "@/services/axios";
import * as Sentry from "@sentry/vue";
import {BrowserTracing} from "@sentry/tracing";
import Keycloak from "keycloak-js";

Vue.$rbac = [];

const routes = [
    {path: '/', component: index},
    {path: '/register', component: signup},
    {path: '/member/dashboard', component: dashboard},
    {path: '/member/analytics', component: analytics},
    {path: '/member/profile', component: profile},
    {path: '/member/airlines', component: airlines},
    {path: '/applications', component: applications},
    {path: '/privacy-policy', component: privacy_policy},
    {
      path: "*",
      component: Vue.component("page-not-found", {
        template: "",
        created: function () {
          window.location.href = "/";
        }
      })
    }
  ];

  const router = new VueRouter({
    mode: 'history',
    routes, // short for `routes: routes`
  });
  let infoLoaded = false;
  router.beforeEach((to, from, next) => {
    if (infoLoaded) {
      next();
      return
    }
    let ls = window.localStorage
    if (ls.getItem("logged")) {
      let rbacBefore = window.localStorage.getItem('rbac');
      Vue.$rbac = JSON.parse(rbacBefore)
      axios.get('/agent/account/info').then((res) => {
        infoLoaded = true
        // let lsBefore = JSON.stringify(window.localStorage)
        let result = res.data;
        ls.setItem('role', result.data.role);
        ls.setItem('isConsumerOwner', result.data.is_consumer_owner);
        ls.setItem('email', result.data.email);
        ls.setItem('agencyStatus', result.data.agency_status);
        ls.setItem('isSuperagency', result.data.is_superagency);
        ls.setItem('agency', result.data.agency);
        ls.setItem('agencyID', result.data.agency_id);
        Vue.$rbac = JSON.parse(rbacBefore)
        let rbacAfter = JSON.stringify(result.data.rbac);
        if (result.data.role !== 'manager' && result.data.role !== 'subagency_manager') {
          ls.clear();
          next({path:'/'})
          return
        }
        next()
        // let lsAfter = JSON.stringify(window.localStorage)
        // if (lsBefore != lsAfter) {
        //   location.reload();
        // }
        if (rbacBefore != rbacAfter) {
          window.localStorage.setItem('rbac', rbacAfter)
          location.reload();
        }
      }).catch(err => {
        console.error(err)
        next()
      })
    } else {
      next();
    }
  })

// Interceptor to add Authorization header
axios.interceptors.request.use((config) => {
  const token = Vue.prototype.$keycloak.token;
  const agency = window.localStorage.getItem('agency');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  if (agency) {
    config.headers['Ag-Agency'] = agency;
  }
  return config
})

let notificationShown = false;

// Interceptor to handle 401 errors
axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response) {
        const { status, data } = error.response;
        const message = data && (data.detail || data.error);

        if (status === 401 || status === 403) {
          if (!notificationShown && message) {
            Vue.prototype.$notify({
              group: 'foo',
              type: 'error',
              title: 'Error',
              text: message,
            });
            notificationShown = true;

            setTimeout(() => {
              notificationShown = false;
            }, 4000);
          }
          if (status === 401) {
            helpers.methods.logout();
          }
        }
      }
      return Promise.reject(error);
    }
);

  Sentry.init({
    Vue,
    dsn: "https://6fac6b6203a44d64ae2dc4c8b2cc877d@o557238.ingest.sentry.io/4504572024782848",
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracePropagationTargets: [/^.*hub.airgateway.*$/],
      }),
      new Sentry.Replay({
        maskAllText: false,
        maskAllInputs: false
      })
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.01,
  });

// Global Error Handler
Vue.config.errorHandler = function (err, vm, info) {
  err.name = '[AGENCY-PORTAL] ' + err.name;
  Sentry.captureException(err, scope => {
    scope.setUser({username: window.localStorage.getItem('email')});
    return scope;
  });
}

  export default {
    name: 'app',
    router,
    components: {
      NavigationBar,
    },
    props: {keycloak: Keycloak},
    mounted() {},
    methods: {},
  }
</script>

<style lang="scss">

  .main-container {
    margin-top: 80px;
  }

  footer {
    p {
      font-size: 13px;
      text-align: center;
    }
  }

  #app {
    .main-container-header {
      display: flex;

      h2 {
        font-family: "Montserrat", sans-serif;
        font-size: 2rem;
        font-weight: 500;
        letter-spacing: -0.08rem;
        padding-left: 0.5rem;
        margin: 0;
      }
    }

    .vue-notification {
      text-align: center;
      
      .notification-title {
        font-size: 16px;
      }

      .notification-content {
        font-size: 14px;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: #FFFFFF;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 8px !important;
    background-color: #c1c1c1;
  }

</style>
